module.exports = __webpack_public_path__ + "static/media/mockupCelular.6ce54add.png";